import ClayButton from "@clayui/button";
import ClayModal, { useModal } from "@clayui/modal";
import React from "react";
import { t } from "i18next";

const Dialog = (props) => {
  const { observer, onClose } = useModal({
    onClose: () => {
      props.setVisible(false);
    },
  });

  const { size = "full-screen", title, message } = props;

  return (
    <ClayModal observer={observer} size={size} className="provider-modal">
      <div>
        {title && <ClayModal.Header>{title}</ClayModal.Header>}

        {props.children && (
          <ClayModal.Body>{props.children}</ClayModal.Body>
        )}

        <ClayModal.Footer
          first={<h5>{message}</h5>}
          last={
            <ClayButton displayType="secondary" onClick={onClose}>
              {t("ok")}
            </ClayButton>
          }
        />
      </div>
    </ClayModal>
  );
};

export default Dialog;
